module.exports = __webpack_public_path__ + "img/result_desk_lx_angle.4b32254a.jpg";